import React from 'react';
import { QueryKey } from 'react-query';
import includes from 'lodash/includes';

import { I18nText } from '../../../../../types';
import { UniversalFilterView } from '../../UniversalFilter.types';
import {
  UniversalFilterCompanyNanoIdValue,
  UniversalFilterCompanyNanoIdModes,
  UniversalFilterCompanyNanoIdOnChange
} from './UniversalFilterCompanyNanoId.types';

import { useUniversalFilterCompanyNanoId } from './hooks/useUniversalFilterCompanyNanoId';

import { TeamsMultiSelect } from '../../../../../main/teams/helpers/TeamsMultiSelect';

import { UniversalFilterTemplate } from '../../helpers/UniversalFilterTemplate';

interface UniversalFilterCompanyNanoIdProps {
  filterView?: UniversalFilterView;
  filterStateCacheKey: QueryKey;
  filterValue?: UniversalFilterCompanyNanoIdValue;
  i18nName: I18nText;
  autoFocus?: boolean;
  onChange: UniversalFilterCompanyNanoIdOnChange;
}

function UniversalFilterCompanyNanoId({
  filterView,
  filterStateCacheKey,
  filterValue,
  i18nName,
  autoFocus,
  onChange
}: UniversalFilterCompanyNanoIdProps) {
  const { modeOptions, filterState, handleModeChange, handleCompanyIdsChange } =
    useUniversalFilterCompanyNanoId({
      filterStateCacheKey,
      filterValue,
      onChange
    });

  return (
    <UniversalFilterTemplate<UniversalFilterCompanyNanoIdModes>
      filterView={filterView}
      i18nName={i18nName}
      selectedMode={filterState.mode}
      modeOptions={modeOptions}
      onModeChange={handleModeChange}
    >
      {includes(
        [UniversalFilterCompanyNanoIdModes.CONTAINS_ANY_OF],
        filterState.mode
      ) ? (
        <TeamsMultiSelect
          value={filterState.companyNanoIds || []}
          autoFocus={autoFocus}
          onChange={handleCompanyIdsChange}
        />
      ) : null}
    </UniversalFilterTemplate>
  );
}

export default UniversalFilterCompanyNanoId;
